import axiosInstance from "./axiosInstance";

const chatSupportLogService = {
  getAccess: async () => (await axiosInstance.get("/admin/chat-support-log/access")).data,
  getTargets: async (params = {}) =>
    (await axiosInstance.get("/admin/chat-support-log/targets", { params })).data,
  saveTargets: async (payload) =>
    (await axiosInstance.put("/admin/chat-support-log/targets", payload)).data,
  getCustomerLogs: async (params = {}) =>
    (await axiosInstance.get("/admin/chat-support-log/customers", { params })).data,
  getPendingCustomerLogs: async (params = {}) =>
    (await axiosInstance.get("/admin/chat-support-log/customers/pending", { params })).data,
  createCustomerLog: async (payload) =>
    (await axiosInstance.post("/admin/chat-support-log/customers", payload)).data,
  updateCustomerLog: async (id, payload) =>
    (await axiosInstance.put(`/admin/chat-support-log/customers/${id}`, payload)).data,
  deleteCustomerLog: async (id) =>
    (await axiosInstance.delete(`/admin/chat-support-log/customers/${id}`)).data,
  approveCustomerLog: async (id, payload) =>
    (await axiosInstance.put(`/admin/chat-support-log/customers/${id}/approval`, payload)).data,
  getActivityLogs: async (params = {}) =>
    (await axiosInstance.get("/admin/chat-support-log/activity", { params })).data,
  getPendingActivityLogs: async (params = {}) =>
    (await axiosInstance.get("/admin/chat-support-log/activity/pending", { params })).data,
  createActivityLog: async (payload) =>
    (await axiosInstance.post("/admin/chat-support-log/activity", payload)).data,
  updateActivityLog: async (id, payload) =>
    (await axiosInstance.put(`/admin/chat-support-log/activity/${id}`, payload)).data,
  deleteActivityLog: async (id) =>
    (await axiosInstance.delete(`/admin/chat-support-log/activity/${id}`)).data,
  approveActivityLog: async (id, payload) =>
    (await axiosInstance.put(`/admin/chat-support-log/activity/${id}/approval`, payload)).data,
  saveDailyReport: async (payload) =>
    (await axiosInstance.post("/admin/chat-support-log/daily-report", payload)).data,
  getTeamReports: async (params = {}) =>
    (await axiosInstance.get("/admin/chat-support-log/team-reports", { params })).data,
  approveDailyReport: async (id, payload) =>
    (await axiosInstance.put(`/admin/chat-support-log/daily-report/${id}/approval`, payload)).data,
  getPerformance: async (params = {}) =>
    (await axiosInstance.get("/admin/chat-support-log/performance", { params })).data,
  getHistory: async (params = {}) =>
    (await axiosInstance.get("/admin/chat-support-log/history", { params })).data,
};

export default chatSupportLogService;
